// extracted by mini-css-extract-plugin
export default {"root":"home_root__WJUgr","App":"home_App__zbUXJ","home-header":"home_home-header__utp0Z","home-header-box":"home_home-header-box__8MYpr"};